import { z } from 'zod';
/**
 * A TELEFONOS UGYFELRENDSZER - honnan jon az ugyfelkartya, es hova megy a
 * hivasjegyzet (Adam dontese 2026-11-03).
 *
 *  - `tt`          Doki-support: ugyfelkartya es kereses a TT-bol, jegyzet a
 *                  WenzTool-ba (TT); ProjectFlow-hivasnal a feladatra is.
 *  - `projectflow` jegyzet a ProjectFlow-feladatra (ha a hivas feladathoz
 *                  kotott), kulonben az AVSlackben marad. TT-adatot nem lat.
 *  - `salesforce`  ugyfeladat a Salesforce-bol - HAMAROSAN; addig ugy
 *                  viselkedik, mint a `none`.
 *  - `none`        csak az AVSlack sajat cimjegyzeke; a jegyzet az AVSlackben
 *                  marad.
 *
 * A ceg ad alapertelmezest, felhasznalonkent felulirhato; mindkettot a ceg
 * adminja vagy a szuperadmin allitja - a TT belso ugyfeladat, ez jogosultsag.
 */
export const customerSystems = ['tt', 'projectflow', 'salesforce', 'none'];
export const customerSystemSchema = z.enum(customerSystems);
export const customerSystemLabels = {
    tt: 'TT',
    projectflow: 'ProjectFlow',
    salesforce: 'Salesforce',
    none: 'Egyik sem',
};
/** Hova kerult (kerul) egy hivasjegyzet. */
export const callNoteDestinations = ['tt', 'projectflow', 'avslack'];
/** A ceg alapertelmezese, illetve a felhasznalo felulirasa (`null` = a cege). */
export const teamCustomerSystemInput = z.object({ customerSystem: customerSystemSchema });
export const userCustomerSystemInput = z.object({
    customerSystem: customerSystemSchema.nullable(),
});
/** A tenylegesen ervenyes ertek: a felhasznaloe, ha van, kulonben a cege. */
export function effectiveCustomerSystem(userValue, teamValue) {
    const parse = (value) => customerSystemSchema.safeParse(value).data ?? null;
    return parse(userValue) ?? parse(teamValue) ?? 'none';
}
//# sourceMappingURL=customer-system.js.map